import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { AGGridImportRowData } from './types';

interface SkipRowRendererProps extends ICellRendererParams {
  value: boolean;
  data: AGGridImportRowData
}

export function SkipRowRenderer(props: SkipRowRendererProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.setValue(event.target.checked);
  };

  return (
    <>
      <div className={`ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper ${props.value ? 'ag-checked' : ''}`}>
        <input
          type="checkbox"
          checked={props.value}
          onChange={handleChange}
          className="ag-input-field-input ag-checkbox-input"
        />
      </div>
      {props.data.skip_reason && (
        <span className="px-2 py-1 text-xs font-medium resource-import-edit-grid__duplicate-indicator">
          {props.data.skip_reason}
        </span>
      )}
    </>
  );
}
